import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type StudioHierarchyBulkActions = {
  studioHierarchyWorkflowStateId: string[];
  studioHierarchyItemId: string[];
};

export const studioHierarchyBulkActionsSlice = createSlice({
  name: 'studioHierarchyBulkSelection',
  initialState: {
    studioHierarchyWorkflowStateId: [],
    studioHierarchyItemId: [],
  },
  reducers: {
    resetStudioHierarchyBulkSelection: (state) => {
      state.studioHierarchyItemId = [];
      state.studioHierarchyWorkflowStateId = [];
    },
    updateSelectedHierachyItems: (state, { payload: selectedHierarchyItemIds }: PayloadAction<string[]>) => {
      state.studioHierarchyItemId = selectedHierarchyItemIds;
    },
    addSelectedWorkflowState: (state, { payload: workflowStateId }: PayloadAction<string>) => {
      state.studioHierarchyWorkflowStateId.push(workflowStateId);
    },
    removeSelectedWorkflowState: (state, { payload: workflowStateId }: PayloadAction<string>) => {
      state.studioHierarchyWorkflowStateId = state.studioHierarchyWorkflowStateId.filter((id) => id !== workflowStateId);
    },
  },
});

export const { resetStudioHierarchyBulkSelection, updateSelectedHierachyItems, addSelectedWorkflowState, removeSelectedWorkflowState } = studioHierarchyBulkActionsSlice.actions;

export default studioHierarchyBulkActionsSlice.reducer;
